export default __webpack_public_path__ + "static/media/524.43980197.png";